import { render, staticRenderFns } from "./MassFootMenu.vue?vue&type=template&id=22f62f1e&scoped=true&"
import script from "./MassFootMenu.vue?vue&type=script&lang=js&"
export * from "./MassFootMenu.vue?vue&type=script&lang=js&"
import style0 from "./MassFootMenu.vue?vue&type=style&index=0&id=22f62f1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f62f1e",
  null
  
)

export default component.exports